export const QA_NAME_PREVIEW_CLOSE_SPLIT = 'previewCloseSplit'
